import {PopupContainer} from "@FRAMEWORK/ui/mobile/popup";
import {BlueText} from "@FRAMEWORK/ui/mobile/text";
import {Area} from "@FRAMEWORK/ui/mobile/layout";
import BulletListItem from "@FRAMEWORK/ui/mobile/list/BulletListItem";
import * as style from "@COMPONENTS/style/detailpackage/pointM";
import {Table} from "@FRAMEWORK/ui/mobile/table";
import {OverlayState} from "@/hooks/common/useOverlay";
import useEventMileage, {EventMileage} from "@QUERIES/prdt/event/useEventMileage";
import {format} from "@yb/utils";
import dayjs from "dayjs";
import {memo} from "react";
import {onClickSSO} from "@COMPONENTS/common/commonUtil";
import publicRuntimeConfig from "@FRAMEWORK/config/public";

interface PointSavePopupProps extends OverlayState {
	evCd: string;
}

const PointSavePop = (props: PointSavePopupProps) => {
	const {evCd, ...overlayProps} = props;
	const useEvtMileage = useEventMileage(evCd);
	const mileage = useEvtMileage.data?.body || [];

	const adtMlgPoint = (item: EventMileage) => {
		let mlgPoint = item.mlgPoint;
		if (item.mlgSaveKindCd === "R1") {
			mlgPoint = Math.round(((item.adtPrice + item.airtaxAdtCost + item.bafAdtCost) * item.mlgPoint) / 100);
		}
		return mlgPoint;
	};

	return (
		<PopupContainer {...overlayProps} size="full" title="적립 예상 노랑풍선 포인트" padding={false} animate="slideIn">
			<Area>
				<style.Title>
					적립 예상 포인트<span>(예상 적립일자 2023 12월 31일)</span>
				</style.Title>
				<style.CotentBox>
					<style.PointWrap>
						{mileage &&
							mileage.map((item, index) => (
								<li key={index}>
									<p>{item.mlgGb} (성인 1인 기준)</p>
									<BlueText>
										<em>{format.koKRFormatNumber(adtMlgPoint(item))}</em>P
									</BlueText>
								</li>
							))}
					</style.PointWrap>
				</style.CotentBox>
			</Area>
			{mileage && (
				<style.PromotionWrap>
					<style.Title line={true}>진행중인 프로모션</style.Title>
					<Table types="vertical">
						<caption>적립 예상 포인트 정보</caption>
						<colgroup>
							<col style={{width: "45%"}} />
							<col style={{width: "22%"}} />
							<col style={{width: "33%"}} />
						</colgroup>
						<tbody>
							<tr>
								<th scope="col">
									<style.TextAlign>프로모션</style.TextAlign>
								</th>
								<th scope="col">
									<style.TextAlign>적립</style.TextAlign>
								</th>
								<th scope="col">
									<style.TextAlign>기간</style.TextAlign>
								</th>
							</tr>
							{mileage.map((item, index) => {
								const link =
									item.webBannerLink === "OUTLINK"
										? item.bnrLink
										: `${publicRuntimeConfig.ENV_PACKAGE_M_URL}/promotion/promotionDetail.yb?mstNo=${item.bnrMstNo}`;
								return (
									index !== 0 &&
									item.mlgDivi === "MLG" && (
										<tr key={index}>
											<td>
												<style.PromotionName href={link} target="_blank" onClick={e => onClickSSO(e, link)}>
													{item.promotionNm}
												</style.PromotionName>
											</td>
											<td>
												<style.TextAlign>
													{item.mlgPoint}
													{item.mlgUnit}
												</style.TextAlign>
											</td>
											<td>
												<style.TextAlign>
													{dayjs(item.mlgStartDt).format("YYYY.MM.DD")}~<br />
													{dayjs(item.mlgEndDt).format("YYYY.MM.DD")}
												</style.TextAlign>
											</td>
										</tr>
									)
								);
							})}
							{mileage.length === 1 && (
								<tr>
									<td colSpan={3}>
										<style.TextAlign>진행중인 프로모션이 없습니다.</style.TextAlign>
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</style.PromotionWrap>
			)}
			<style.NotiBox>
				<style.InfoTitle>유의 사항</style.InfoTitle>
				<style.BulletList>
					<BulletListItem>만 14세 이상 노랑풍선 회원만 적립 가능합니다. (여행객 개별 적립)</BulletListItem>
					<BulletListItem>
						포인트는 온라인 회원가입(포인트 동의 포함) 후 실제 여행을 다녀오신 여행자를 대상으로 개별 적립됩니다. (만
						14세 미만 포인트 적립 불가)
					</BulletListItem>
					<BulletListItem>
						여행상품 구매 및 여행 완료 후 결제금액의 1% 포인트를 적립해드립니다. (1포인트 =1원)
					</BulletListItem>
					<BulletListItem>
						결제 시 포인트로 사용한 금액 및 할인을 제외한 나머지 금액에 대하여 포인트를 적립해드립니다.
					</BulletListItem>
					<BulletListItem>
						여행 완료 후 한국 도착일 기준 7일째 되는 날 자정에 자동 적립됩니다.
						<br /> 예) 2023년 1월 1일 도착(귀국)했을 경우 → 1월 7일까지 회원가입 완료 및 내 예약 찾기/매핑 완료 → 1월
						8일 00시 자동 적립
					</BulletListItem>
					<BulletListItem>
						비회원의 경우 자동적립일 기준일 이전에 회원가입 후 별도 적립됩니다.
						<br />
						(적립 기준일 이후에는 포인트 적립 불가)
					</BulletListItem>
					<BulletListItem>
						프로모션 / 이벤트에 따라 정책 및 적립 기준일 상이해, 프로모션 정책이 포인트 정책보다 우선 적용될 수
						있습니다.
					</BulletListItem>
					<BulletListItem>적립 가능 상품 : 적립 불가 상품을 제외한 국내/외 여행 상품</BulletListItem>
					<BulletListItem>
						적립 불가 상품 : 자유여행(항공권/호텔/액티비티/KTX/렌터카 등), 패키지여행(단품, 특가상품), 홈쇼핑/일반 제휴/
						소셜 커머스 상품, 그 외 노랑풍선 지정 일부 상품
					</BulletListItem>
					<BulletListItem>
						포인트 결제 가능 : 국내/해외 여행상품, 실시간 해외 항공권(일부 불가 조건 아래 참고),
						<br />
						실시간 호텔, 액티비티, KTX, 렌터카
					</BulletListItem>
					<BulletListItem>
						포인트 결제 불가 : 실시간 항공권, 외부 채널 상품(제휴 채널, 홈쇼핑 등), 그 외 노랑풍선 지정 일부 상품
					</BulletListItem>
					<BulletListItem>
						추가 적립 프로모션은 중복으로 적용되지 않으며, 가장 큰 혜택을 제공하는 1개 프로모션 기준으로 적립됩니다.
					</BulletListItem>
				</style.BulletList>
			</style.NotiBox>
		</PopupContainer>
	);
};

export default memo(PointSavePop);
